module.exports = __webpack_public_path__ + "img/2g.aaa7a4cb.png";